import { cn } from "@/lib/utils";

export const PageHeader = ({ title, subtitle, children, className }) => (
  <div className={cn("flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between", className)}>
    <div>
      <h1 className="font-heading text-2xl font-bold tracking-tight text-foreground sm:text-3xl">
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2">{children}</div>}
  </div>
);

export default PageHeader;
